import React from 'react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowRotateLeftSolid,
  faArrowRotateRightSolid,
  faCompressSolid,
  faExpandSolid,
  faMagnifyingGlassMinusSolid,
  faMagnifyingGlassPlusSolid,
  faRulerHorizontalSolid,
} from '@/lib/fa'


const DiscViewerActionButtons = ({
  zoom,
  onZoomIn,
  onZoomOut,
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  compactView,
  onToggleCompactView,
  showDistance,
  onToggleDistance,
}: {
  zoom: number
  onZoomIn: () => void
  onZoomOut: () => void
  canUndo: boolean
  canRedo: boolean
  onUndo: () => void
  onRedo: () => void
  compactView: boolean
  onToggleCompactView: () => void
  showDistance: boolean
  onToggleDistance: () => void
}) => {
  return (
    <div className="tw-absolute tw-right-5 tw-top-5 tw-z-[100] tw-flex tw-flex-col tw-items-center tw-gap-1 tw-rounded tw-border tw-border-slate-200 tw-bg-white tw-p-1.5 tw-shadow-sm">
      <ActionBtn
        title={
          compactView
            ? 'Zmniejsz skan tarczki'
            : 'Skan na całą tarczę (jak w WPF)'
        }
        onClick={onToggleCompactView}
        active={compactView}
        icon={(compactView ? faExpandSolid : faCompressSolid) as IconProp}
      />
      <ActionBtn
        title={showDistance ? 'Ukryj punkty dystansu' : 'Pokaż punkty dystansu'}
        onClick={onToggleDistance}
        active={showDistance}
        icon={faRulerHorizontalSolid as IconProp}
      />
      <div className="tw-my-0.5 tw-h-px tw-w-6 tw-bg-slate-200" />
      <ActionBtn
        title="Cofnij (Ctrl+Z)"
        disabled={!canUndo}
        onClick={onUndo}
        icon={faArrowRotateLeftSolid as IconProp}
      />
      <ActionBtn
        title="Ponów (Ctrl+Y)"
        disabled={!canRedo}
        onClick={onRedo}
        icon={faArrowRotateRightSolid as IconProp}
      />
      <div className="tw-my-0.5 tw-h-px tw-w-6 tw-bg-slate-200" />
      <ActionBtn
        title="Powiększ"
        onClick={onZoomIn}
        icon={faMagnifyingGlassPlusSolid as IconProp}
      />
      <span className="tw-py-0.5 tw-font-mono tw-text-xs tw-text-slate-500">
        {Math.round(zoom * 100)}%
      </span>
      <ActionBtn
        title="Pomniejsz"
        onClick={onZoomOut}
        icon={faMagnifyingGlassMinusSolid as IconProp}
      />
    </div>
  )
}

export default DiscViewerActionButtons

function ActionBtn({
  icon,
  title,
  onClick,
  disabled,
  active,
}: {
  icon: IconProp
  title: string
  onClick: () => void
  disabled?: boolean
  active?: boolean
}) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      disabled={disabled}
      className={[
        'tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded tw-border tw-text-sm',
        disabled
          ? 'tw-cursor-not-allowed tw-border-slate-300 tw-bg-white tw-opacity-40'
          : active
            ? 'tw-border-blue-600 tw-bg-blue-50 tw-text-blue-700'
            : 'tw-border-slate-300 tw-bg-white tw-text-slate-700 hover:tw-border-slate-500 hover:tw-bg-slate-50',
      ].join(' ')}
    >
      <FontAwesomeIcon icon={icon} />
    </button>
  )
}
